import { FileManagement } from '@/components/FileManagement';
import React from 'react';



const FileManage = () => {
    return (
        <div>
            <FileManagement
                tableName='All'
                recordId={null}
                equipmentId={null}
            />
        </div>
    );
};

export default React.memo(FileManage);